// extracted by mini-css-extract-plugin
export var base = "_2w-0";
export var updateBanner = "_2w-1";